// Native
import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router/Router";
import store from "./store";
import vuetify from "./plugins/vuetify";

// Styles
import "./styles/main.sass";

// Erro sempre ser Roboto
import "./styles/globals.css";

// Plugins
import axios from "./plugins/plugin-axios";
import request from "./plugins/plugin-request";
import formdata from "./plugins/plugin-formdata";
import localStorage from "./plugins/plugin-localStorage";
import infotable from "./plugins/plugin-infotable";
import date from "./plugins/plugin-date";
import print from "./plugins/plugin-print";
import bet from "./plugins/plugin-bet";
import icon from "./plugins/plugin-icon";
import app from "./plugins/plugin-app";
import profile from "./plugins/plugin-profile";
import copy from "./plugins/plugin-copy";
import utils from "./plugins/plugin-utils";
import VueMask from "v-mask";
import * as VueGoogleMaps from "vue2-google-maps";
import i18n from "@/plugins/i18n";
import gmt from "./plugins/plugin-gmt";
import VueCryptojs from "vue-cryptojs";
import permission from "@/plugins/permission";
import OtpInput from "@bachdgvn/vue-otp-input";
import VuePapaParse from "vue-papa-parse";

Vue.use(axios)
  .use(request)
  .use(formdata)
  .use(localStorage)
  .use(infotable)
  .use(date)
  .use(print)
  .use(bet)
  .use(icon)
  .use(app)
  .use(profile)
  .use(VueMask)
  .use(copy)
  .use(utils)
  .use(gmt)
  .use(VueCryptojs)
  .use(permission)
  .use(VuePapaParse);

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAQUZ99Z9IwpCwSu0hHYU5xaoeAzArmllQ",
  },
  installComponents: false,
});

Vue.component("google-map", VueGoogleMaps.Map);
Vue.component("google-marker", VueGoogleMaps.Marker);
Vue.component("google-info-window", VueGoogleMaps.InfoWindow);
Vue.component("v-otp-input", OtpInput);

Vue.config.productionTip = false;

new Vue({
  i18n,
  vuetify,
  store,
  router,
  mounted() {
    /// Theme Dark
    const dark = this.$localStorage.getItem("dark", "string");
    if (dark === "false") {
      this.$vuetify.theme.dark = false;
    }
    // Refresh Token important! (Fix solved: F5 update page.)
    const auth = this.$localStorage.getItem("auth", "string");
    if (auth === "true") {
      const token = this.$localStorage.getItem("token", "string");
      this.$axios.defaults.headers.common["Application-Authorization"] = token;
    }
  },
  render: (h) => h(App),
}).$mount("#app");
